import PageWrapper from "../components/PageWrapper";
import dynamic from "next/dynamic";
import Head from "next/head";
import { useTranslation } from "next-translate";

const ComingSoon = dynamic(() => import("../components/comingSoon"), {
  ssr: false,
});

const _ComingSoon = () => {
  const { t, lang } = useTranslation();

  return (
    <PageWrapper>
      <Head>
        <title>{lang === "en" ? "Coming Soon" : "قريباً"}</title>
      </Head>
      <ComingSoon />
    </PageWrapper>
  );
};

export default _ComingSoon;
